import script from "./ReferralProgramDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReferralProgramDescription.vue?vue&type=script&setup=true&lang=ts"

import "./ReferralProgramDescription.vue?vue&type=style&index=0&id=f0561592&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0561592"]])

export default __exports__